class PaginationController {
  constructor({ deskLimit = 12, mobLimit = 12, onChange = null } = {}) {
    this.deskLimit = deskLimit;
    this.mobLimit = mobLimit;
    this.onChange = onChange;
    this.currentLimit = this.getLimit();
    this.bindResizeListener();
  }
  getLimit() {
    return window.innerWidth > 768 ? this.deskLimit : this.mobLimit;
  }
  bindResizeListener() {
    let resizeTimer;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        var _a;
        const newLimit = this.getLimit();
        if (newLimit !== this.currentLimit) {
          this.currentLimit = newLimit;
          (_a = this.onChange) == null ? void 0 : _a.call(this, newLimit);
        }
      }, 200);
    });
  }
}
function trapFocus(container) {
  const focusableSelectors = [
    "a[href]",
    "area[href]",
    'input:not([disabled]):not([type="hidden"])',
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "iframe",
    "object",
    "embed",
    "[contenteditable]",
    '[tabindex]:not([tabindex="-1"])'
  ];
  if (typeof container._removeFocusTrap === "function") {
    container._removeFocusTrap();
  }
  function getFocusableElements() {
    return Array.from(container.querySelectorAll(focusableSelectors.join(","))).filter((el) => el.offsetParent !== null);
  }
  function handleKeydown(e) {
    if (e.key !== "Tab") return;
    const focusableEls = getFocusableElements();
    const firstEl = focusableEls[0];
    const lastEl = focusableEls[focusableEls.length - 1];
    if (focusableEls.length === 0) return;
    if (e.shiftKey) {
      if (document.activeElement === firstEl) {
        e.preventDefault();
        lastEl.focus();
      }
    } else {
      if (document.activeElement === lastEl) {
        e.preventDefault();
        firstEl.focus();
      }
    }
  }
  function handleEscape(e) {
    if (e.key === "Escape") {
      if (typeof container._onEscape === "function") {
        container._onEscape();
      }
    }
  }
  document.addEventListener("keydown", handleKeydown);
  document.addEventListener("keydown", handleEscape);
  container._removeFocusTrap = () => {
    document.removeEventListener("keydown", handleKeydown);
    document.removeEventListener("keydown", handleEscape);
  };
  const first = getFocusableElements()[0];
  if (first) first.focus();
}
function intelliSuggest(ssData) {
  if (!ssData) return;
  window._JK = window._JK || {};
  window._JK.intelliSuggest = window._JK.intelliSuggest || {};
  ssData.forEach((product) => {
    window._JK.intelliSuggest[product.handle] = {
      intellisuggestData: product.intellisuggestData,
      intellisuggestSignature: product.intellisuggestSignature
    };
  });
}
export {
  PaginationController as P,
  intelliSuggest as i,
  trapFocus as t
};
